module.exports = __webpack_public_path__ + "img/ra-ur3.95528edf.jpg";